import { render } from "./CustomImpactSlider.vue?vue&type=template&id=1980b4cc&scoped=true"
import script from "./CustomImpactSlider.vue?vue&type=script&lang=js"
export * from "./CustomImpactSlider.vue?vue&type=script&lang=js"

import "./CustomImpactSlider.vue?vue&type=style&index=0&id=1980b4cc&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1980b4cc"]])

export default __exports__